export default "__VITE_ASSET__DWlhpSFm__"